import type { PostForQuickPost } from "@circle-react/components/QuickPost/types";
import { useModal } from "@ebay/nice-modal-react";

import { ModalManager } from "../Layout/ModalManagerProvider";
import { PostMomentumModalV4 } from "./PostMomentumModalV4";
import { useConvertPostToBroadcast } from "./useConvertPostToBroadcast";

export const PostMomentumModal = ModalManager.create(function PostMoMo({
  post,
}: {
  post: PostForQuickPost;
}) {
  const modal = useModal();
  const { onShareViaBroadcast, isPending } = useConvertPostToBroadcast();

  const handleShareViaBroadcast = () => {
    onShareViaBroadcast({
      postId: post.id,
      onSuccess: () => void modal.hide(),
    });
  };

  return (
    <PostMomentumModalV4
      isOpen={modal.visible}
      isLoading={isPending}
      spaceName={typeof post.space_name === "string" ? post.space_name : ""}
      onClose={modal.hide}
      onShareViaBroadcast={handleShareViaBroadcast}
    />
  );
});
